/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Boards extends CacheEnabledApiClient {
  constructor() {
    super('boards', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'board';
  }

}

export default new Boards();
